import type { ProfilePageResponse } from 'tradera/backend/features/discover/profile-page-data';

export type ProfileState = {
    isTranslationOnDemandDisabled: boolean;
    loadingModel: boolean;
    model: Model | null;
    showTranslatedReviews: boolean;
    translatedReviews: [];
    translatedReviewsLoading: boolean;
    translatedReviewsLoadingError: boolean;
};

export type MutualFeedbackRemovalItem = {
    transactionId: number;
    transactionIdUrl: string;
    feedbackRemovalRequestId: number;
    feedbackRemovalRequestIdUrl: string;
    mutualFeedbackRemovalStatus: string;
    status: string;
    statusText: string;
};

export type FeedbackItem = {
    feedbackMemberId: number;
    feedbackMemberAlias: string;
    slugifiedFeedbackMemberAlias: string;
    feedbackMemberTotalRating: number;
    feedbackMemberRole: string;
    rating: string;
    hasText: boolean;
    text: string;
    hasReply: boolean;
    reply: string;
    created: string;
    createdDateTime: string;
    createdString: string;
    createdAgo: string;
    hasItemDescription: boolean;
    itemDescription: string;
    itemId: number;
    currentMemberId: number;
    isReplyAllowed: boolean;
    gradeId: number;
    categoryId: number;
    endDate: string;
    hasPassed120Days: boolean;
    canonicalUrl: string;
    mutualFeedbackRemovalItem?: MutualFeedbackRemovalItem;
    feedBackMemberRoleDescription: string;
    feedbackMemberCountryCodeIso2: string;
};

type FeedbackSummaryForPeriod = {
    totalNegative: number;
    totalPositive: number;
};

export type TotalFeedbackSummaryForMember = {
    memberId: number;
    lastMonth: FeedbackSummaryForPeriod;
    lastSixMonths: FeedbackSummaryForPeriod;
    lastTwelveMonths: FeedbackSummaryForPeriod;
    sinceRegistration: FeedbackSummaryForPeriod;
    unique: FeedbackSummaryForPeriod;
};

type DetailedSellerRatingSummaryForMember = {
    itemDescriptionCategoryCount: number;
    communicationCategoryCount: number;
    deliveryTimeCategoryCount: number;
    itemDescriptionAverageRating: number;
    itemDescriptionAverageRatingInPercent: string;
    communicationAverageRating: number;
    communicationAverageRatingInPercent: string;
    deliveryTimeAverageRating: number;
    deliveryTimeAverageRatingInPercent: string;
    totalAverageRating: number;
    itemDescriptionAverageRatingClass: string;
    communicationAverageRatingClass: string;
    deliveryTimeAverageRatingClass: string;
};

type TouchwebProfilePaginationLink = {
    href: string;
    textString: string;
    cssClass: string;
    rel: string;
};

export type TouchwebProfilePagination = {
    pageLinks: TouchwebProfilePaginationLink[];
    prev: TouchwebProfilePaginationLink;
    next: TouchwebProfilePaginationLink;
};

export type Model = {
    publicProfile: ProfilePageResponse;
    feedbackItems: FeedbackItem[];
    detailedSellerRatingSummaryForMember?: DetailedSellerRatingSummaryForMember;
    hasFeedbackItems: boolean;
    totalFeedbackSummaryForMember: TotalFeedbackSummaryForMember;
    memberSince: string;
    accountState: string;
    currentRoleFilter: string;
    currentRatingFilter: string;
    existsInFavouriteSellers: boolean;
    pagination: TouchwebProfilePagination;
    feedbackItemsTotalCount: number;
};

export default (): ProfileState => {
    return {
        isTranslationOnDemandDisabled: false,
        loadingModel: false,
        model: null,
        showTranslatedReviews: false,
        translatedReviews: [],
        translatedReviewsLoading: false,
        translatedReviewsLoadingError: false,
    };
};
